<template>
  <div>
    <div class="row">
      <div class="col-md-8 col-md-offset-2">
        <div class="card card-wizard" id="wizardCard">
          <form-wizard shape="tab"
                       @on-complete="wizardComplete"
                       error-color="#EB5E28"
                       color="#66615B"
                       title="Ajout d'une boutique"
                       subtitle="">
            <tab-content title="Nom et adresse"
                         :before-change="validateFirstStep"
                         icon="ti-home">
              <first-step ref="firstStep"></first-step>
            </tab-content>

            <tab-content title="Informations supplémentaires"
                         :before-change="validateSecondStep"
                         icon="ti-settings">
              <second-step ref="secondStep"></second-step>
            </tab-content>

            <tab-content title="Validation"
                         icon="ti-check">
              <h2 class="text-center text-space">Votre boutique est prête !
                <br>
                <small>Cliquer sur "<b>Terminer</b>" pour finaliser l'ajout de votre boutique.</small>
              </h2>
            </tab-content>

            <button slot="prev" class="btn btn-default btn-fill btn-wd btn-back">Retour</button>
            <button slot="next" class="btn btn-info btn-fill btn-wd btn-next">Suivant</button>
            <button slot="finish" :disabled="loading" class="btn btn-info btn-fill btn-wd">{{ loading ? 'Ajout...' : 'Terminer' }}</button>
          </form-wizard>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import {FormWizard, TabContent} from 'vue-form-wizard'
  import 'vue-form-wizard/dist/vue-form-wizard.min.css'
  import FirstStep from '@/components/Store/Add/FirstStep.vue'
  import SecondStep from '@/components/Store/Add/SecondStep.vue'
  import swal from 'sweetalert2'
  import api from '@/api'
  export default {
    data () {
      return {
        store: {},
        loading: false
      }
    },
    components: {
      FormWizard,
      TabContent,
      FirstStep,
      SecondStep
    },
    methods: {
      validateFirstStep () {
        return this.$refs.firstStep.validate()
      },
      validateSecondStep () {
        return this.$refs.secondStep.validate()
      },
      wizardComplete () {
        // we gather models from all steps into one model
        this.store = {
          ...this.$refs.firstStep.model,
          ...this.$refs.secondStep.model,
          created: new Date(),
          updated: new Date()
        }
        this.loading = true
        api.store.add(this.store, (store) => {
          swal('Terminé !', `Votre boutique ${this.store.name} a été ajoutée`, 'success')
          .then((value) => {
            this.$router.push({name: 'StoreList'})
          })
          this.loading = false
        }, (error) => {
          swal('Erreur !', `La boutique n'a pas pu être mise à jour : ${error}`, 'success')
          this.loading = false
        })
      }
    }
  }
</script>
<style>
  .vue-form-wizard .wizard-icon-circle.tab_shape {
    background-color: #9A9A9A !important;
    color: white;
  }
</style>



// WEBPACK FOOTER //
// src/pages/Company/Store/Edit.vue